import { useState } from "react";
import { Star, X, Send, Loader2 } from "lucide-react";
import { api, fmtErr } from "../lib/api";
import { toast } from "sonner";

const TEXTS = {
  low: {
    title: "Mi dispiace, miglioriamo anche grazie a te.",
    body: "Mi dispiace che questa lettura non ti abbia soddisfatta pienamente. Arcana è in continua evoluzione e il tuo parere è importante.",
    question: "Ci racconti che cosa non ha funzionato?",
  },
  high: {
    title: "Grazie per aver scelto Arcana!",
    body: "Siamo in costante crescita e miglioramento, e il tuo parere ci aiuta a rendere ogni consultazione sempre migliore.",
    question: "Che cosa ti è piaciuto di più di questa lettura?",
  },
};

export const FeedbackStelle = ({ sourceType = "lettura", sourceId, testid }) => {
  const [stars, setStars] = useState(0);
  const [modal, setModal] = useState(false);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);
  const [voted, setVoted] = useState(false);

  if (!sourceId) return null;
  const t = stars <= 3 ? TEXTS.low : TEXTS.high;

  const rate = async (n) => {
    if (busy || voted) return;
    setStars(n);
    setBusy(true);
    try {
      await api.post("/feedback", { source_type: sourceType, source_id: sourceId, stars: n });
      setVoted(true);
      setModal(true);
    } catch (e) {
      setStars(0);
      toast.error(fmtErr(e, "Non riesco a registrare la valutazione. Riprova."));
    } finally {
      setBusy(false);
    }
  };

  const sendComment = async () => {
    if (!comment.trim()) { setModal(false); return; }
    setBusy(true);
    try {
      await api.post("/feedback", { source_type: sourceType, source_id: sourceId, stars, comment: comment.trim() });
      toast.success("Grazie per il tuo parere.");
    } catch (e) {
      toast.error(fmtErr(e, "Non riesco a inviare il commento. Riprova."));
    } finally {
      setBusy(false);
      setModal(false);
    }
  };

  return (
    <div className="mt-5 text-center" data-testid={`${testid}-feedback`}>
      <p className="text-[11px] uppercase tracking-[0.25em] text-purple-300/50 mb-2">Valuta questa lettura</p>
      <div className="flex items-center justify-center gap-1.5" data-testid={`${testid}-feedback-stars`}>
        {[1, 2, 3, 4, 5].map((n) => (
          <button
            key={n}
            type="button"
            onClick={() => rate(n)}
            disabled={busy || voted}
            data-testid={`${testid}-feedback-star-${n}`}
            aria-label={`${n} ${n === 1 ? "stella" : "stelle"}`}
            className="p-1 transition-transform hover:scale-110 disabled:cursor-default"
          >
            <Star
              className={`w-5 h-5 transition-colors duration-300 ${
                n <= stars ? "text-amber-400 fill-amber-400" : "text-purple-300/40 hover:text-amber-300/70"
              }`}
            />
          </button>
        ))}
      </div>

      {modal && (
        <div className="fixed inset-0 z-50 overflow-y-auto bg-black/60 backdrop-blur-sm" data-testid={`${testid}-feedback-modal`}>
          <div className="min-h-full flex items-center justify-center px-4 py-6">
          <div className="mystic-card w-full max-w-xs max-h-[calc(100dvh-3rem)] overflow-y-auto p-5 text-center relative border-amber-500/30">
            <button
              onClick={() => setModal(false)}
              data-testid={`${testid}-feedback-close`}
              aria-label="Chiudi senza scrivere"
              className="absolute top-2.5 right-2.5 p-1.5 text-purple-300/50 hover:text-amber-300 transition-colors"
            >
              <X className="w-4 h-4" />
            </button>
            <p className="font-display text-base text-amber-100 leading-snug pr-4" data-testid={`${testid}-feedback-title`}>{t.title}</p>
            <p className="text-xs text-purple-200/70 mt-2.5 leading-relaxed" data-testid={`${testid}-feedback-body`}>{t.body}</p>
            <p className="text-xs text-purple-100/85 mt-3 mb-2 font-medium" data-testid={`${testid}-feedback-question`}>{t.question}</p>
            <textarea
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              rows={3}
              maxLength={600}
              placeholder="Facoltativo: scrivi qui il tuo pensiero…"
              data-testid={`${testid}-feedback-comment`}
              className="input-dark text-left"
            />
            <div className="flex items-center justify-center gap-3 mt-3.5">
              <button
                onClick={sendComment}
                disabled={busy}
                data-testid={`${testid}-feedback-send`}
                className="gold-btn px-4 py-1.5 text-[11px] inline-flex items-center gap-1.5 disabled:opacity-50"
              >
                {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Send className="w-3 h-3" />}
                Invia
              </button>
              <button
                onClick={() => setModal(false)}
                data-testid={`${testid}-feedback-skip`}
                className="text-[11px] text-purple-300/60 hover:text-purple-200 transition-colors"
              >
                Chiudi senza scrivere
              </button>
            </div>
          </div>
          </div>
        </div>
      )}
    </div>
  );
};
